import { useEffect, useRef, useState } from 'react';
import http from 'hub-http/clients/apiClient';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { EditIcon } from 'foundations-assets';
import { AutoSizedTextInput } from 'foundations-components/transitional/components/AutoSizedTextInput';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { useContentObjectType } from 'content-management-data-lib';
import useUpdateContentObject from '../hooks/useUpdateContentObject';
import { showErrorNotification } from '../utils/alertUtils';
import { useContentDetailsDataProvider } from '../providers/ContentDetailsDataProvider';
import { updateTitle } from '../utils/reconciliationUtils';
import useUsageTrackerProps from '../hooks/useUsageTrackerProps';
import { DETAILS_INTERACTION } from '../constants/trackerEvents';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const updateContentTitle = ({
  contentId,
  contentObjectType,
  title
}) => {
  return http.patch(`content-management/actions/v1/${contentObjectType}/${contentId}/update-name`, {
    data: {
      name: title
    }
  });
};
const EditableContentTitle = ({
  initialTitle,
  contentId
}) => {
  const {
    contentObjectType,
    contentObjectTypeSingularNoun
  } = useContentObjectType();
  const {
    contentObject
  } = useContentDetailsDataProvider();
  const {
    tracker
  } = useUsageTrackerProps();
  const {
    updateContentObject
  } = useUpdateContentObject();
  const [contentTitle, setContentTitle] = useState(initialTitle);
  const [showInputForTitle, setShowInputForTitle] = useState(false);
  const titleInput = useRef(undefined);
  useEffect(() => {
    if (showInputForTitle && titleInput.current) {
      titleInput.current.focus();
    }
  }, [showInputForTitle]);
  const handleTitleRename = () => {
    setShowInputForTitle(false);
    if (!contentTitle) {
      setContentTitle(initialTitle);
      return;
    }
    if (initialTitle !== contentTitle) {
      updateContentTitle({
        contentId,
        title: contentTitle,
        contentObjectType
      }).then(() => {
        const updatedContentObject = updateTitle(contentObject, contentTitle);
        updateContentObject(updatedContentObject);
      }).catch(err => {
        showErrorNotification({
          options: {
            contentObjectTypeSingularNoun
          },
          action: 'updateTitle',
          response: err
        });
      });
    }
  };
  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      handleTitleRename();
    }
    if (e.key === 'Escape') {
      // reset the text back to original name of content
      setShowInputForTitle(false);
      setContentTitle(initialTitle);
    }
  };
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    direction: "row",
    justify: "start",
    wrap: "nowrap",
    children: [/*#__PURE__*/_jsx("div", {
      "data-test-id": "editable-content-title",
      style: {
        maxWidth: '50vw'
      },
      children: showInputForTitle ? /*#__PURE__*/_jsx(AutoSizedTextInput
      // The type in react is defined as MutableRefObject<HTMLInputElement | undefined> even though the returned value is MutableRefObject<HTMLInputElement> and this prop can only accept MutableRefObject<HTMLInputElement>
      , {
        inputRef: titleInput,
        onBlur: handleTitleRename,
        onChange: e => setContentTitle(e.target.value),
        onKeyDown: handleKeyDown,
        value: contentTitle
      }) : /*#__PURE__*/_jsx(TruncateString, {
        useFlex: true,
        children: contentTitle
      })
    }), showInputForTitle ? null : /*#__PURE__*/_jsx(IconButton, {
      onClick: () => {
        setShowInputForTitle(true);
        tracker.track(DETAILS_INTERACTION, {
          action: 'clicked-edit-title-button'
        });
      },
      placement: "right",
      use: "link",
      children: /*#__PURE__*/_jsx(View, {
        as: "span",
        marginInlineStart: "100",
        children: /*#__PURE__*/_jsx(EditIcon, {})
      })
    })]
  });
};
export default EditableContentTitle;